const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Users Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Invitations the service defined to manage Invitations
 * @argument {Resource} Overview the resource defined to get Overview queries
 */
app.controller('overviewUsersController', ['Application', 'Authorization', 'Analyze', 'Overview', 'Users', 'AccessHelper', '$translate', function(Application, Authorization, Analyze, Overview, Users, AccessHelper, $translate) {
    var self = this;
    self.usersCurrentTab = 'confirmed';

    if (!AccessHelper.allowGeneralActivity('users', ['admin'])) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.allowance = {
      add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
      bulk_add: AccessHelper.isAllowed(['admin', 'users', 'bulk_add'], null, ['admin']),
      edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
      view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
      suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
      password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin'])
    };

    self.accessed = {confirmed: true};
    self.tabChange = function(tab) {
      self.accessed[tab] = true;
      self.usersCurrentTab = tab;
    };

    self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;

    self.translations = {};

    self.information = {
      users: [0, 0],
      sessionsLastMonth: 0,
      openInvitations: 0,
      maxModal: false
    };

    self.reports = {
      csv_confirmed: Application.API + '/learn/v3/users/report/csv_confirmed?authtoken=' + Authorization.getAuthToken().authtoken,
      csv_pending: Application.API + '/learn/v3/users/report/csv_pending?authtoken=' + Authorization.getAuthToken().authtoken,
      csv_suspended: Application.API + '/learn/v3/users/report/csv_suspended?authtoken=' + Authorization.getAuthToken().authtoken,
      csv_all: Application.API + '/learn/v3/users/report/csv_all?authtoken=' + Authorization.getAuthToken().authtoken
    };

    self.initialize = function() {

      //get number of total and new users
      Overview.totals({subresource: "users", users: "all"}, function(data) {
        self.information.users = [data['total_users'], data['new_users']];
        if (data['total_users'] === 0) {
          self.information.users = [1, 0];
        }
      }, function(error) {
        console.log('Error getting overview totals:', error);
      });

      Users.seatStatus().$promise
          .then(function(data) {
            self.information.seatsPurchased = data.purchased_seats && parseInt(data.purchased_seats) || 0;
            self.information.seatsUsed = data.filled_seats && parseInt(data.filled_seats) || 0;
            self.information.seatsPending = data.pending_users && parseInt(data.pending_users) || 0;
            self.information.availableLicenses = self.information.seatsPurchased - self.information.seatsUsed;

            self.information.percentOpen = self.information.availableLicenses / self.information.seatsPurchased * 100;
            if (self.information.percentOpen <= 5) {
              self.information.maxModal = true;
              return;
            }
          });

      //get sessions of past 30 days
      var subresource = {subresource: "authtokens", users: "all", action: "signin"};
      Analyze.totals(subresource, function(data) {
        self.information.sessionsLastMonth = data['total_authtokens'] - data['total_authtokens_up_to_last_month'];
      }, function(error) {
        console.log('Error getting totals:', error);
      });

    };


    self.refreshItems = {
      active: false,
      pending: false,
      suspended: false
    };

    self.setRefresh = function(type) {
      for (var key in self.refreshItems) {
        if (type === key) {
          continue;
        }
        self.refreshItems[key] = true;
      }
    };

    $translate([
      'overviewUsers.registered_in_total',
      'overviewUsers.past_30_days',
      'overviewUsers.still_pending',
      'overviewUsers.stats.users',
      'overviewUsers.stats.new_users',
      'overviewUsers.stats.sessions',
      'overviewUsers.stats.invitations'
    ]).then(function (translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);
  